import { IColunasSettingsUser } from "@app/shared/utils/validar_settings_user";

export const COLUNAS_DEFAULT_MODULE_VENDAS = [
  {
    module: 'VEN_CAIXA',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'numero'
      },
      {
        active: true,
        removable: false,
        field: 'terminal.descricao'
      },
      {
        active: true,
        removable: true,
        field: 'created_by_user.name'
      },
      {
        active: true,
        removable: true,
        field: 'created_at'
      },
      {
        active: true,
        removable: true,
        field: 'status_dh'
      },
      {
        active: true,
        removable: true,
        field: 'valor_total'
      },
      {
        active: true,
        removable: true,
        field: 'status',
      }
    ]
  },
  {
    module: 'VEN_TABELA_PRECO_FABRICA',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'descricao',
        active: true,
        removable: false
      },
      {
        field: 'modelo.descricao',
        active: true,
        removable: true
      },
      {
        field: 'is_valid',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'VEN_PEDIDO_VENDA',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: false
      },
      {
        field: 'pre_cadastro_nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'vendedor_apelido_nome_fantasia',
        active: true,
        removable: true
      },
      {
        field: 'data_hora',
        active: true,
        removable: true
      },
      {
        field: 'previsao_entrega',
        active: true,
        removable: true
      },
      {
        field: 'valor_total',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'VEN_ORDEM_SERVICO',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: false
      },
      {
        field: 'parceiro_nome',
        active: true,
        removable: false
      },
      {
        field: 'data_solicitacao',
        active: true,
        removable: true
      },
      {
        field: 'previsao_entrega',
        active: true,
        removable: true
      },
      {
        field: 'valor_total',
        active: true,
        removable: true
      },
      {
        field: 'eventos',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
] as IColunasSettingsUser[];
